import React, {useState} from "react";
import {Col, Form, InputGroup} from "react-bootstrap";

const NumericInputComponent = (props) => {

    const [type, setType] = useState("single");

    const renderMultiNumeric = () => {
        if (type === 'multi') {
            return(
                <Form.Control
                    type="number"
                    name={`${props.field.name}-mr-2`}
                    onChange={props.formik.handleChange}
                    value={props.formik.values[`${props.field.name}-mr-2`]}
                    onBlur={props.formik.handleBlur}
                    className="inputClear"
                    style={{fontSize: "13px", height:"40px", color: "#000000"}}
                />
            );
        }
    };

    const handleWhenChangeOption = () => {
        if (document.getElementById(props.field.name + "-mr-filter-type").value === "NUMERIC_BETWEEN"){
            setType("multi");
        }else {
            setType("single")
        }
    }

    return(
        <Form.Group as={Col} md="4">
            <Form.Label>{props.field.name}</Form.Label>
            <InputGroup >
                <Form.Control
                    type="number"
                    name={props.field.name}
                    onChange={props.formik.handleChange}
                    value={props.formik.values[`${props.field.name}`]}
                    onBlur={props.formik.handleBlur}
                    className="inputClear"
                    style={{fontSize: "13px", height:"40px", color: "#000000"}}
                />
                {renderMultiNumeric()}
                <Form.Control
                    onChange={() => handleWhenChangeOption()}
                    value={props.formik.values[`${props.field.name}-mr-filter-type`]}
                    as="select"
                    id={props.field.name + "-mr-filter-type"}
                    name={props.field.name + "-mr-filter-type"}
                    style={{height: "40px", width: "110px", maxWidth: "110px"}}>
                    <option selected="selected" key={props.field.name + "-filter-type-equals"} onClick={() => setType("single")} value={'NUMERIC_EQUALS'}>Equals</option>
                    <option key={props.field.name + "-filter-type-less"} onClick={() => setType("single")} value={'NUMERIC_LESS'}>Less</option>
                    <option key={props.field.name + "-filter-type-greater"} onClick={() => setType("single")} value={'NUMERIC_GREATER'}>Greater</option>
                    <option key={props.field.name + "-filter-type-between"} onClick={() => setType("multi")} value={'NUMERIC_BETWEEN'}>Between</option>
                </Form.Control>
            </InputGroup>
        </Form.Group>
    );

}

export default NumericInputComponent;
